import mapProps from 'recompose/mapProps';

const formatPrismicData = mapProps(({ primary, ...props }) => ({
  ...primary,
  ...props
}));

export default formatPrismicData;
